import Helper from '../helper';

export default class Applink {

    constructor() {
        this.el = document.getElementById('downloadApp');

        this.appLinks = {
            'Mac' : 'https://awclient.anywhereworks.com/v1/download-client/AnywhereWorks',
            'Windows' : 'https://awclient.anywhereworks.com/v1/download-client/AnywhereWorks',
            'Android' : 'https://play.google.com/store/apps/details?id=com.full.aw',
            'iOS' : 'https://itunes.apple.com/in/app/anywhereworks/id1318693182?mt=8'
        };
    }


    set() {
        window.open(this.appLinks[Helper.getOS()]);
    }


    bind() {
        if (!!this.el) {
            this.el.addEventListener('click', (el) => {
                el.preventDefault();
                this.set();
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/components/applink.js